export default __webpack_public_path__ + "static/media/01_DAIF_Data_02_01_loop.8a3d547e.mp4";